<template>
  <div class="app-avatar" :class="[avatarSize]">
    <span class="app-avatar__image" v-if="userPhoto && !imageError">
      <img :src="userPhoto" @error="imageLoadError" />
    </span>
    <span v-else class="app-avatar__text" id="tooltip-button-1">
      <!-- <b-tooltip
          :show="show"
          target="tooltip-button-1"
          variant="light"
          triggers="focus"
        >
        <div class="tooltip-content">
            <b-button @click="onClose" class="tooltip-button-x">x</b-button>
                Coloque uma foto sua para aumentar sua visibilidade na plataforma.<br />
            <router-link to="/profile">
              <b-button class="tooltip-button" size="sm">
                Adicionar foto
              </b-button>
            </router-link>
        </div>
      </b-tooltip> -->
      <strong>
        {{ nameInitials }}
      </strong>
    </span>
  </div>
</template>

<script>
import { getNameInitials } from "../utils/getNameInitials";

export default {
  name: "Avatar",
  props: {
    src: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    }
  },
  data() {
    return {
      imageError: false
      // show: true
    };
  },
  // beforeMount() {
  //   this.hideTooltip()
  // },
  methods: {
    imageLoadError() {
      this.imageError = true;
    }
    // onClose() {
    //   this.show = false
    // },
    // hideTooltip() {
    //   if (this.show && this.$route.name == 'Profile' || this.$route.name == 'Room') {
    //     this.show = false
    //   } else {
    //     this.show = true
    //   }
    // },
  },
  computed: {
    currentUser() {
      return this.$store.state.user.currentUser;
    },
    userPhoto() {
      if (this.src === "") return this.currentUser.photo;
      return this.src;
    },
    nameInitials() {
      return getNameInitials(this.name);
      // const userName = this.name ? this.name : this.currentUser.name;
      // const splittedName = userName.replace(/\s+/g, ' ').trim().split(' ');
      // const firstNameFirstLetter = splittedName[0][0];
      // const secondNameFirstLetter = splittedName[1][0];
      // return firstNameFirstLetter + secondNameFirstLetter;
    },
    avatarSize() {
      return this.size === "sm" ||
        this.size === "md" ||
        this.size === "lg" ||
        this.size === "xl"
        ? `app-avatar-${this.size}`
        : "app-avatar-md";
    }
  }
};
</script>

<style scoped>
.tooltip-content {
  background-color: #ffffff;
  background-position: absolute;
  padding: 10px;
  margin-top: -4px;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: -4px;
  color: black;
  border: 2px solid #d81a67;
  display: flex;
  flex-direction: column;
}
.tooltip-button {
  margin-left: 80px;
  margin-top: 10px;
  margin-bottom: 5px;
  background: white !important;
  color: #d81a67;
  border: 1px solid #d81a67;
}

.tooltip-button-x {
  background-color: #ffffff;
  background-position: absolute;
  padding-top: 0px;
  padding-bottom: 23px;
  padding-left: 7px;
  padding-right: 15px;
  height: 11px;
  border-radius: 20px;
  margin-left: 155px;
  margin-bottom: 4px;
  color: #d81a67;
  border: 1px solid #d81a67;
  font-size: 15px;
}
</style>
